import React from 'react';
import {Location} from 'history';

export const FormTabsContext = React.createContext<{
    getActiveTabName: (location: Location) => string | number,
    isActiveTab: (location: Location, tabName: string | number) => boolean,
    isVisibleTab: (tabName: string | number) => boolean,
    changeVisibility: (tabName: string | number, newState: boolean) => void,
    setBadge: (tabName: string | number, badge: null | { color?: string, label: string }) => void,
    isExclamationSignDisplayed: (tabName: string | number) => boolean,
    toggleExclamationSign: (tabName: string | number, state?: boolean | null) => void,
    toggleErrorExclamationSign: (tabName: string | number, state?: boolean | null) => void,
    showExclamationSign: (tabName: string | number) => void,
    hideExclamationSign: (tabName: string | number) => void,
} | null>(null);
